import { Container, Title, GoBackIcon } from './styles';

import IconArrowBack from '../../assets/ArrowBack.png';
import IconClose from '../../assets/Close.png';
import { Page, useMainRouter } from '../../Router/pageComponents';
import useOnCloseSchedule from '../../hooks/useOnCloseSchedule';

interface HeaderProps {
  title: string;
  hasGoBackButton?: boolean;
  hasCloseButton?: boolean;
}

const HeaderUpload = ({ title, hasGoBackButton, hasCloseButton }: HeaderProps) => {
  const { onCloseSchedule } = useOnCloseSchedule({});
  const { goBack: mainRouterGoBack } = useMainRouter();

  return (
    <Container>
      {hasGoBackButton && (
        <GoBackIcon onClick={() => mainRouterGoBack()}>
          <img src={IconArrowBack} alt="" />
        </GoBackIcon>
      )}
      {hasCloseButton && (
        <GoBackIcon onClick={() => onCloseSchedule()}>
          <img src={IconClose} alt="" />
        </GoBackIcon>
      )}
      <Title>{title}</Title>
    </Container>
  );
};

export { HeaderUpload };
